module.exports = __webpack_public_path__ + "static/media/fluxwheel.cc3e525d.jpg";